import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/root-store/app-state';
import * as routerSelectors from 'src/app/root-store/root-store.selector';

@Component({
  selector: 'app-function-deliverables',
  templateUrl: './function-deliverables.component.html',
  styleUrls: ['./function-deliverables.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FunctionDeliverablesComponent implements OnInit {
  nodeId$: Observable<number>;
  displayedColumns: string[] = [
    'packageCode',
    'documentNumber',
    'title',
    'responsible',
    'startDate',
    'endDate',
    'hours',
    'progressWorkflowStatus',
    'percentageCompleted',
    'controlledDocument',
    'actions',
  ];
  constructor(private store$: Store<AppState>) {}

  ngOnInit(): void {
    this.nodeId$ = this.store$.select(routerSelectors.getIdSelector);
  }
}
